import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '@/modules/admin-access-codes/styles.less';
import { getRegistrationCodes } from '@/entities/admin-access-codes/admin-access-codes.api';
import DataGridTable from '@/common/components/DataGridTable/index';
import Filters from '@/modules/admin-access-codes/components/Filters';
import GenerateAccessCode from '@/modules/admin-access-codes/components/GenerateAccessCode';
import { getAccessCodesColumns } from '@/modules/admin-access-codes/config';
import {
  adminAccessCodesQueryKeys,
  useAdminAccessCodesResellersQuery,
} from '@/entities/admin-access-codes';

const AdminAccessCodesModule = () => {
  const { t } = useTranslation();
  const columns = useMemo(() => getAccessCodesColumns(t), [t]);
  const { data: resellersData } = useAdminAccessCodesResellersQuery();
  const resellerOptions = useMemo(() => resellersData?.data ?? [], [resellersData]);

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <h3 className={styles.pageHeaderTitle}>{t('Access Codes')}</h3>
        <GenerateAccessCode resellerOptions={resellerOptions} />
      </div>
      <div className={styles.pageBody}>
        <div className={styles.tableWrap}>
          <DataGridTable
            className={styles.table}
            columns={columns}
            defaultQueryParams={{
              search: '',
              status: '',
              resellerId: '',
              sortBy: 'createdAt',
              sortOrder: 'DESC',
            }}
            emptyState={
              <span>
                {t('No access codes yet.\nGenerate your first code to get started.')}
              </span>
            }
            emptyStateClassName={styles.noList}
            queryFn={getRegistrationCodes}
            queryKey={adminAccessCodesQueryKeys.codes()}
            renderFilters={({ params, updateTableParams }) => (
              <Filters
                search={params.search}
                status={params.status}
                resellerId={params.resellerId}
                sortBy={params.sortBy}
                sortOrder={params.sortOrder}
                resellerOptions={resellerOptions}
                onSearchChange={(search) =>
                  updateTableParams({ search }, { resetPage: true })
                }
                onStatusChange={(status) =>
                  updateTableParams({ status }, { resetPage: true })
                }
                onResellerChange={(resellerId) =>
                  updateTableParams({ resellerId }, { resetPage: true })
                }
              />
            )}
            syncSortWithQuery
          />
        </div>
      </div>
    </div>
  );
};

export default AdminAccessCodesModule;
